module.exports = __webpack_public_path__ + "img/sail-croatia-logo-small.2b4fa943.svg";